import { API_HELPER } from '@/helpers/api.js';

const API_ROOT_SERVICE = "ExperienceAvailabilities";

export const experienceAvailabilitiesService = {
  getList(input) {
    const url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);
    const requestOptions = {
      method: 'GET',
      headers: { "Content-Type": "application/json" }
    };
    return API_HELPER.apiCall(url, input, requestOptions);
  }
};


